import { Injectable } from '@angular/core';
import { getCountryDetailsQuery } from '@graphql/address';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@services/ui/toast.service';
import { Apollo } from 'apollo-angular';
import {
  GetCountryDetailsQuery,
  GetCountryDetailsQueryVariables,
} from 'gql/graphql';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountryDetailsService {
  countryDetails = new BehaviorSubject<
    GetCountryDetailsQuery['getCountryDetails']
  >({
    currencies: [],
    time_zones: [],
  });

  constructor(
    private readonly apollo: Apollo
  ) {}

  getCountryDetails(label: string) {
    this.apollo
      .watchQuery<GetCountryDetailsQuery, GetCountryDetailsQueryVariables>({
        query: getCountryDetailsQuery,
        variables: { label: label },
      })
      .valueChanges.subscribe({
        next: ({ data }) => {
          this.countryDetails.next(data.getCountryDetails);
        },
        error: (err) => {
          //let errMsg = getErrorMessage(err, this.translate);
          //this.toast.notifyError(errMsg);
        },
      });
  }
}
